module.exports = __webpack_public_path__ + "static/media/partnerships-for-the-goals.872af437.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/partnerships-for-the-goals.png
// module id = 579
// module chunks = 0